/*
 * Get-restaurant.ts
 * Description: Includes the declaration
 * of the function for getting a restaurant
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing functions
import normalize from 'normalize-json-api-response';

/**
 * Getting a certain restaurant
 *
 * @return {Object} Promise - a list of restaurants
 * @param {String} slug - id of a restaurant
 */
export function getRestaurant(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(normalize(response.data));
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Getting a certain restaurant preview
 *
 * @return {Object} Promise - a list of restaurants
 * @param {String} slug - id of a restaurant
 */
export function getRestaurantPreview(slug: string) {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug,
            method: 'get',
            data: {},
        }).then((response) => {
            resolve(response.data.data.attributes);
        }).catch(() => {
            reject();
        });
    });
}
